module.exports = __webpack_public_path__ + "img/kunming02.13371bc7.png";